export enum Collection {
    Greetings = 'greetings',
    Products = 'products',
}